<section *ngIf='show' style="padding: 20px;padding-top: 10px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h4 style="float: left;">All Brokers : </h4>
                <div style="clear: both; margin-bottom: 5px;"></div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-12">
                            <input placeholder="Search By Name" [(ngModel)]='searchName' id='plaho' class="p-1 mb-2" type="text" style="width: 100%; height: 25px;border: 1px solid black !important; color: black !important;">
                        </div>
                        <div class="col-lg-3 col-12" *ngIf='add'>
                            <button (click)='addS()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height: 0; " type="button" class="btn btn-secondary mb-2">Add Brokers</button>
                        </div>
                        <div class="col-lg-3 col-12">
                            <button (click)='trigger()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height: 0; " type="button" class="btn btn-secondary mb-2">Add Brokers By File Excel</button>
                            <input id="excel" style="overflow: hidden !important;display: none;" name='excel' (change)='goFile($event)' class="text mt-2 d1" type="file" placeholder="الصور" required="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive" style="overflow: auto;height: 67.2vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">No.</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Phone</th>
                                    <th scope="col">Phone2</th>
                                    <th scope="col">City</th>
                                    <th scope="col">Adress</th>
                                    <!-- <th scope="col">Date</th> -->
                                    <th scope="col" *ngIf='update'>Update</th>
                                    <th scope="col" *ngIf='delete'>Delete</th>
                                    <th scope="col">Quotations</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arre|searchName:searchName|serchCodeSupplier:serchCodeVisit; let n = index;'>
                                    <th scope="row" style="text-align: center;">{{n+1}}</th>
                                    <td data-title="Name">{{v.name}}</td>
                                    <td data-title="Email">{{v.email}}</td>
                                    <td data-title="Phone">0{{v.phone}}</td>
                                    <td data-title="Phone2">0{{v.phone2}}</td>
                                    <td data-title="City">{{v.city}}</td>
                                    <td data-title="Adress">{{v.adress}}</td>
                                    <!-- <td data-title="Date">{{v.date}}</td> -->
                                    <td data-title="Update" *ngIf='update'><button (click)='upU(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                                    <td data-title="Delete" *ngIf='delete'><button (click)='delS(v.id , v.name)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
                                    </td>
                                    <td data-title="Quotations"><button (click)='delS000(v.id)' type="button" class="btn btn-dark" style="box-shadow: none;"><i class="fas fa-eye"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addS0(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
                          <label style="color: white;">Name : </label>
        <input style="height: 25px;" class="text mt-2 d1" type="text" name="name" [(ngModel)]='name' placeholder="Name" required="">
        <label style="color: white;" class="mt-2">Email : </label>
        <input style="height: 25px;" class="text mt-2 d1" type="text" name="email" [(ngModel)]='email' placeholder="Email" required="">
        <label style="color: white;" class="mt-2">City : </label>
        <input style="height: 25px;" class="text mt-2 d1" type="text" name="city" [(ngModel)]='city' placeholder="City" required="">
        <label style="color: white;" class="mt-2">Adress : </label>
        <input style="height: 25px;" class="text mt-2 d1" type="text" name="adress" [(ngModel)]='adress' placeholder="Adress" required="">
        <label style="color: white;" class="mt-2">Phone : </label>
        <input style="height: 25px;" class="text mt-2 d1" type="number" name="phone" [(ngModel)]='phone' placeholder="Phone" required="">
        <label style="color: white;" class="mt-2">Phone2 : </label>
        <input style="height: 25px;" class="text mt-2 d1" type="number" name="phone2" [(ngModel)]='phone2' placeholder="Phone2" required="">
        <!-- <input  class="text mt-2 d1" type="number" name="pay" [(ngModel)]='pay' placeholder="أضافة مدفوعات" required=""> -->
          <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add">
          <div style="clear: both;"></div>
          </span>
                    </form>
                </div>
            </div>
        </div>
    </section>

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
      <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Delete confirmation">
      <div style="clear: both;"></div>
      </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data124='ngForm' (submit)='okUp(data124.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                      <label style="color: white;">Name : </label>
            <input style="height: 25px;" class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
            <label style="color: white;" class="mt-2">Email : </label>
            <input style="height: 25px;" class="text mt-2 d1" type="text" name="emailU" [(ngModel)]='emailU' placeholder="Email" required="">
            <label style="color: white;" class="mt-2">City : </label>
            <input style="height: 25px;" class="text mt-2 d1" type="text" name="cityU" [(ngModel)]='cityU' placeholder="City" required="">
            <label style="color: white;" class="mt-2">Adress : </label>
            <input style="height: 25px;" class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Adress" required="">
            <label style="color: white;" class="mt-2">Phone : </label>
            <input style="height: 25px;" class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
            <label style="color: white;" class="mt-2">Phone2 : </label>
            <input style="height: 25px;" class="text mt-2 d1" type="number" name="phone2U" [(ngModel)]='phone2U' placeholder="Phone 2" required="">
              <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Update">
              <div style="clear: both;"></div>
        </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd023" style="overflow-y: scroll;">
    <div class="card text-center m-5" style="padding: 10px;overflow-x: scroll;">
        <i (click)='close0093()' class="fas fa-times m-4" style="color: black; cursor: pointer; text-align: right;"></i>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 mb-3">
                    <h2 style="font-size: 20px;">Total Money : {{allMoney}}</h2>
                </div>
                <div class="col-lg-4 col-12">
                    <label>From : </label><br>
                    <input (change)='gototo()' id="fromDG" placeholder="Search By Code" class="p-1 mb-2" type="date" style="width: 94.5%; height: 25px;border: 1px solid black !important; color: black !important;" [value]="from">
                </div>
                <div class="col-lg-4 col-12">
                    <label>To : </label><br>
                    <input (change)=gotofrom() id="toDG" placeholder="Search By Code" class="p-1 mb-2" type="date" style="width: 94.5%; height: 25px;border: 1px solid black !important; color: black !important;" [value]="to">
                </div>
                <div class="col-lg-4 col-12">
                    <label>Submit Search Date : </label><br>
                    <button (click)='goDate()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 94.5%; height: 25px;border: 1px solid black !important;line-height:0;">Submit Search</button>
                </div>
            </div>
        </div>
        <table class="table table-striped table-sm" style="text-align: center; direction: ltr;">
            <thead>
                <tr>
                    <th>Number</th>
                    <th>Invoice Code</th>
                    <th>Customer</th>
                    <th>Money</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor='let v of arre0987; let n = index;'>
                    <th scope="row">{{n+1}}</th>
                    <td>{{v.id}}</td>
                    <td>{{v.customerName}}</td>
                    <td>{{v.pay}}</td>
                    <td>{{v.date|date:'dd-MM-yyyy'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</section>